/**
 * Pyramid + dice-rolled-this-leg panel. Top: dice still inside the pyramid
 * (face-down). Bottom: the rolls so far this leg, in order, as pip dice.
 */

import type { CamelUp, DiceResult } from '@mdev/common'
import { CU, CU_HEADING } from '../theme'
import { Die, Panel, PanelTitle } from './pieces'

type CamelUpState = CamelUp.CamelUpState

interface Props {
  state: CamelUpState
}

export function PyramidPanel(props: Props) {
  const { state } = props
  return (
    <Panel>
      <PanelTitle>The Pyramid</PanelTitle>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
        {state.pyramidDice.length === 0 ? (
          <span style={{ fontFamily: CU_HEADING, color: CU.inkSoft }}>Empty — leg over</span>
        ) : (
          state.pyramidDice.map((d, i) => <Die key={`p-${d}-${i}`} die={d} size={34} />)
        )}
      </div>
      <div
        style={{
          fontFamily: CU_HEADING,
          fontSize: 11,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: CU.inkSoft,
          marginBottom: 6,
        }}
      >
        Rolled this leg
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {state.rolledThisLeg.length === 0 ? (
          <span style={{ color: CU.inkSoft }}>—</span>
        ) : (
          state.rolledThisLeg.map((r: DiceResult, i) => (
            <Die key={`r-${i}`} die={r.die} value={r.value} crazyColor={r.crazyColor} size={34} />
          ))
        )}
      </div>
    </Panel>
  )
}
